export const PHI_COOKIE_NAME = 'phi';

export const app_store_link = 'https://appstore.onshape.com/apps/Design%20&%20Documentation/BI4NF3BZAEQXBXOERCYO6NSHJ5Z62TB6ZI472VA=/description';

export const urls = {
    bokeh: [
        'img/Static/px_bokeh.jpg',
        'img/Static/py_bokeh.jpg',
        'img/Static/pz_bokeh.jpg',
        'img/Static/nx_bokeh.jpg',
        'img/Static/ny_bokeh.jpg',
        'img/Static/nz_bokeh.jpg',
    ],

    colors: [
        'img/Static/px_colors.jpg',
        'img/Static/nx_colors.jpg',
        'img/Static/py_colors.jpg',
        'img/Static/ny_colors.jpg',
        'img/Static/pz_colors.jpg',
        'img/Static/nz_colors.jpg',
    ],

    black: [
        'img/Static/px_black.jpg',
        'img/Static/nx_black.jpg',
        'img/Static/py_black.jpg',
        'img/Static/ny_black.jpg',
        'img/Static/pz_black.jpg',
        'img/Static/nz_black.jpg',
    ],

    castle: [
        'img/Static/px_castle.jpg',
        'img/Static/nx_castle.jpg',
        'img/Static/py_castle.jpg',
        'img/Static/ny_castle.jpg',
        'img/Static/pz_castle.jpg',
        'img/Static/nz_castle.jpg',
    ],

    iso: [
        'img/Static/px_iso.jpg',
        'img/Static/nx_iso.jpg',
        'img/Static/py_iso.jpg',
        'img/Static/ny_iso.jpg',
        'img/Static/pz_iso.jpg',
        'img/Static/nz_iso.jpg',
    ],
};

export const colours = {
    light: {
        highlighted: {
            r: 255,
            g: 225,
            b: 80,
        } as const,

        selected: {
            r: 255,
            g: 180,
            b: 0,
        } as const,

        edges: {
            symmetric: {
                error: {
                    r: Math.floor(0.7 * 256),
                    g: Math.floor(0.1 * 256),
                    b: Math.floor(0.1 * 256),
                } as const,

                first: {
                    r: Math.floor(0.7*256),
                    g: Math.floor(0.2*256),
                    b: Math.floor(0.7*256),
                } as const,

                second: {
                    r: Math.floor(0.2*256),
                    g: Math.floor(0.7*256),
                    b: Math.floor(0.7*256),
                } as const,
            } as const,
        } as const,

        axes: {
            body: 0xaaaaaa,
            edges: 0xeeeeee,
            text: 0x7777aa,
            x: 0xffaaaa,
            y: 0xaaffaa,
            z: 0xaaaaff,
            highlight: 2.0,
        } as const,

        clipping: {
            body: 0xaaaaaa,
            edges: 0xeeeeee,
        } as const,
    } as const,

    dark: {
        highlighted: {
            r: 204,
            g: 105,
            b: 0,
        } as const,

        selected: {
            r: 255,
            g: 180,
            b: 0,
        } as const,

        edges: {
            symmetric: {
                error: {
                    r: Math.floor(0.7 * 256),
                    g: Math.floor(0.1 * 256),
                    b: Math.floor(0.1 * 256),
                } as const,

                first: {
                    r: Math.floor(0.7*256),
                    g: Math.floor(0.2*256),
                    b: Math.floor(0.7*256),
                } as const,

                second: {
                    r: Math.floor(0.2*256),
                    g: Math.floor(0.7*256),
                    b: Math.floor(0.7*256),
                } as const,
            } as const,
        } as const,

        axes: {
            body: 0x666666,
            edges: 0xaaaaaa,
            text: 0x333366,
            x: 0xff6666,
            y: 0x66ff66,
            z: 0x6666ff,
            highlight: 0.625,
        } as const,

        clipping: {
            body: 0x666666,
            edges: 0xaaaaaa,
        } as const,
    } as const,
} as const;

export const default_face_color = 0xdce6fa;

export const now = new Date();

export const version = '1.12.2';

export const long_press_sensitivity = 1000/3;

export const vibrate_duration = 75;
